import React from 'react';
import { withStyles } from '@mui/styles';

import CheckIcon from '@mui/icons-material/Check';

const styles = {
  alertContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '60px',
  },
  alert: {
    color: '#fff',
    display: 'flex',
    padding: '40px',
    fontSize: '20px',
    maxWidth: '840px',
    alignItems: 'center',
    background: '#222029',
    boxSizing: 'border-box',
  },
  checkIcon: {
    marginRight: '10px',
  },
};

export default withStyles(styles)(({ classes, node }) => {
  return (
    <div className={classes.alertContainer}>
      <div className={classes.alert}>
        <CheckIcon className={classes.checkIcon} />
        <span>
          Node #{node.id}&nbsp;<strong>{node.title}</strong>&nbsp;was deleted
        </span>
      </div>
    </div>
  );
});
